module.exports = __webpack_public_path__ + "media/audio54.d15bbd9f.mp3";